import Controller from "./listItems.controller";
import template from "./listItems.html";

const listItems = {
  template,
  controller: Controller,
  bindings: {
    title: "@",
    type: "@",
    items: "=",
    headline: "@",
    showSave: "<",
    eventName: "<",
    name: "@",
    isResource: "<",
    isRules: "<",
    isLocationsList: "<",
    isSaveAll: "<",
    resource: "@",
    permissionName: "@",
    extraData: "<",
    isSelectable: "<",
    selectList: "=",
    selectTitle: "=",
    state: "@",
    hideRemove: "<",
    hint: "@",
    hideAdd: "<",
    iconsFlex: "@",
    noItemsText: "@",
    isRequired: "<",
    onFieldChangeEvent: "<",
  },
};

export default listItems;



// WEBPACK FOOTER //
// ./src/components/listItems/listItems.component.js